import { ProcesoRespuestas } from "./ProcesoRespuestas";
import { Respuesta } from "../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { Observable, Subject } from "rxjs";
import { PreguntaDTO, RespuestaEncuesta, RespuestaUsuario } from "@DTOS";
import { Injectable, Injector } from "@angular/core";
import { PasoCargaCache, PasoFiltrado, PasoObtenerRespuestas } from "./Pasos";
import { CloudData } from "angular-tag-cloud-module";
import { CacheRespuestas } from "./CacheRespuestas";

@Injectable({
    providedIn: "root"
})
export class ProcesoRespuestasImpl implements ProcesoRespuestas {
    public terminoCarga$: Observable<void>;

    private _terminoCarga$ = new Subject<void>();
    private respuestas: RespuestaUsuario[] = [];
    private respuestasFiltradas: RespuestaUsuario[] = [];

    constructor(private injector: Injector) {
        this.terminoCarga$ = this._terminoCarga$.asObservable();
    }

    public iniciar(respuestas: RespuestaEncuesta[]): void {
        this.injector.get(CacheRespuestas).limpiar();
        this.respuestas = this.injector.get(PasoCargaCache).cargarDesde(respuestas);
        this.respuestasFiltradas = this.injector.get(PasoFiltrado).filtrar(this.respuestas);
    }

    public iniciarTotales(respuestas: RespuestaEncuesta[]): void {
        this.iniciar(respuestas);
        this._terminoCarga$.next();
    }

    public filtrar(): void {
        this.respuestasFiltradas = this.injector.get(PasoFiltrado).filtrar(this.respuestas);
        this.injector.get(PasoCargaCache).procesarDesde(this.respuestasFiltradas);
    }

    public async obtenerRespuestas(pregunta: PreguntaDTO): Promise<Respuesta[] | CloudData[]> {
        return await this.injector.get(PasoObtenerRespuestas).obtenerRespuestas(pregunta, this.respuestasFiltradas);
    }

    public obtenerRespuestasUsuario(): RespuestaUsuario[] {
        return this.respuestas;
    }

    public obtenerRespuestasUsuarioMostradas(): RespuestaUsuario[] {
        return this.respuestasFiltradas;
    }

    public obtenerTotalRespuestas(): number {
        return this.respuestas.length;
    }

    public obtenerTotalRespuestasMostradas(): number {
        return this.respuestasFiltradas.length;
    }
}
